import { ProCard } from "@ant-design/pro-components";
import { Typography } from "antd";

export const transformGroupToAntdColumn = (rawSchema, { t, styles }) => {
  const column = {
    valueType: 'group',
    columns: [],
  };
  rawSchema.forEach((item) => {
    const antdField = transformFieldToAntdColumn(item, t);
    column.columns.push(antdField);
  });
  return column;
};

const transformDependencyToAntdColumn = (rawSchema, rawValue, { t, styles }) => {
  const { name, columns } = rawSchema;
  const column = {
    valueType: 'dependency',
    name,
    columns: (value) => {
      const originColumns = columns(value);
      return originColumns.map((item) => {
        const antdField = transformFieldToAntdColumn(item, t);
        return antdField;
      });
    },
  };
  return column;
};

const transformFieldToAntdColumn = (field, t) => {
  if (field instanceof Array) {
    return transformGroupToAntdColumn(field, { t });
  }
  const { i18nTitle, title, valueType, fieldProps: originFieldProps, ...restFieldProps } = field;
  let fieldProps = originFieldProps;
  if (!fieldProps) {
    fieldProps = {};
  }
  if (!fieldProps.placeholder) {
    if (['select', 'text', 'digit'].includes(valueType)) {
      fieldProps.placeholder = t(`controls.placeholder.${valueType}`);
    }
  }
  return {
    title: t(i18nTitle, title),
    valueType: valueType,
    fieldProps,
    ...restFieldProps,
  };
};

const transformSetToAntdColumn = (rawSchema, { t, styles, }) => {
  const { name, i18nTitle, title, fields } = rawSchema;
  const column = {
    title: t(i18nTitle, title),
    valueType: 'formSet',
    dataIndex: name,
    transform: (value) => {
      console.log(value);
    },
    colProps: {
      xs: 24,
      sm: 12,
      md: 8,
    },
    rowProps: {
      gutter: [16, 0],
    },
    fieldProps: {
      formItemProps: {
        className: styles?.['form-set'],
      },
    },
    columns: [],
  };
  fields.forEach((field) => {
    const antdField = transformFieldToAntdColumn(field, t);
    antdField.dataIndex = `${name}.${antdField.dataIndex}`;
    column.columns.push(antdField);
  });
  return column;
};

const transformArrayToAntdColumn = (rawSchema, rawValue, { t, styles }) => {
  const { dataIndex, i18nTitle, title, fields } = rawSchema;
  const column = {
    title: t(i18nTitle, title),
    valueType: 'formList',
    dataIndex,
    colProps: {
      xs: 24,
    },
    rowProps: {
      gutter: [16, 0],
    },
    fieldProps: {
      className: styles?.['form-array'],
    },
    max: rawValue.length,
    min: rawValue.length,
    formItemProps: {
      max: rawValue.length,
      min: rawValue.length,
      itemRender: ({ listDom, action }, { record }) => {
        return (
          <ProCard
            bordered
            extra={action}
            title={<Typography.Title level={5}>{t(`constants.form.${record.name}`, record.name)}</Typography.Title>}
            style={{
              marginBlockEnd: 8,
            }}
          >{ listDom }</ProCard>
        );
      },
    },
    columns: [],
  };
  fields.forEach((field) => {
    const antdField = transformFieldToAntdColumn(field, t);
    column.columns.push(antdField);
  });
  return column;
};
export const transformRawSchemaToAntdSchema = (rawSchema, rawValue, { t, styles, }) => {
  const columns = [];
  rawSchema.forEach((item) => {
    if (item.type === 'set') {
      const column = transformSetToAntdColumn(item, { t, styles, });
      columns.push(column);
    } else if (item.type === 'array') {
      columns.push(transformArrayToAntdColumn(item, rawValue[item.dataIndex], { t, styles }));
    } else if (item.type === 'dependency' || item.valueType === 'dependency') {
      columns.push(transformDependencyToAntdColumn(item, rawValue, { t, styles }));
    } else {
      const column = transformFieldToAntdColumn(item, t);
      columns.push(column);
    }
  });
  return columns;
};

// transform value
const transformSetToAntdValue = (rawSchema, rawValue) => {
  const value = {};
  const prefix = rawSchema.name;
  const formSetValue = rawValue[prefix];
  rawSchema.fields.forEach((item) => {
    value[`${prefix}.${item.name}`] = formSetValue[item.name];
  });
  return value;
};

export const transformRawValueToAntdValue = (rawValue, rawSchema) => {
  const value = {};
  rawSchema.forEach((item) => {
    if (item.type === 'set') {
      const set = transformSetToAntdValue(item, rawValue);
      Object.assign(value, set);
    } else {
      value[item.name] = rawValue[item.name];
    }
  });
  return value;
};

// transform antd form value to raw value
const transformAntdSetToRawValue = (antdValue, rawSchema) => {
  const value = {};
  const prefix = rawSchema.name;
  rawSchema.fields.forEach((item) => {
    value[item.name] = antdValue[`${prefix}.${item.name}`];
  });
  return value;
};
export const transformAntdValueToRawValue = (antdValue, rawSchema) => {
  const value = {};
  rawSchema.forEach((item) => {
    if (item.type === 'set') {
      const formSetValue = transformAntdSetToRawValue(antdValue, item);
      value[item.name] = formSetValue;
    } else {
      value[item.name] = antdValue[item.name];
    }
  });
  return value;
};

export const transformRawToAntd = (rawSchema, rawValue, { t, styles, }) => {
  const schema = transformRawSchemaToAntdSchema(rawSchema, rawValue, { t, styles, });
  const value = transformRawValueToAntdValue(rawValue, rawSchema);

  return { schema, value: rawValue };
}